import { render, staticRenderFns } from "./SingleFileHolder.vue?vue&type=template&id=192f95a4&"
import script from "./SingleFileHolder.vue?vue&type=script&lang=ts&"
export * from "./SingleFileHolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports